import { Chip, Typography } from "@mui/material";
import { useEffect, useState } from "react";

const HttpMethodChip = ({ label }) => {
  const [chipColor, setChipColor] = useState();

  const httpMethodsChipColors = [
    { method: "GET", color: "chipGet" },
    { method: "POST", color: "chipPost" },
    { method: "PUT", color: "chipPut" },
    { method: "DELETE", color: "chipDelete" },
  ];

  useEffect(() => {
    httpMethodsChipColors.forEach((method) => {
      if (method.method === label) {
        setChipColor(method.color);
      }
    });
  }, []);

  return (
    <>
      {chipColor && (
        <Chip
          label={<Typography variant="chip">{label}</Typography>}
          color={chipColor}
          size="small"
          sx={{ minWidth: "55px" }}
        />
      )}
    </>
  );
};

export default HttpMethodChip;
